import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { FormHeader } from '../../../components/typography/PopoverTypography';
import { ConfirmButton } from '../../../components/buttons/popoverButtons';
import PhoneNumberInput from '../../../components/inputs/PhoneNumberInput';
import { phoneUtils } from '../../../utils/phoneUtils';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 320px;
`;

interface Props {
  value: string;
  onConfirmPress: (value: string) => void;
}

const UpdatePhoneNumberForm = ({ value, onConfirmPress }: Props) => {
  const { t } = useTranslation('users');
  const [phoneNumber, setPhoneNumber] = useState(value);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLImageElement>) => {
    if (e.key === 'Enter') {
      onConfirmPress(phoneNumber);
    }
  };

  return (
    <FormContainer onKeyDown={handleKeyPress}>
      <FormHeader>{t('update-phone-number.header')}</FormHeader>
      <PhoneNumberInput onChange={value => setPhoneNumber(value)} value={phoneNumber} />
      <ConfirmButton
        label={t('update-phone-number.confirm-btn')}
        onClick={() => onConfirmPress(phoneNumber)}
        disabled={!phoneUtils.isValid(phoneNumber) || value === phoneNumber}
      />
    </FormContainer>
  );
};

export default UpdatePhoneNumberForm;
